export default __webpack_public_path__ + "static/media/BL.VMS.13e9695f.pdf";